var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 35,
    viewBox: "0 0 23 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83545 7.18811H9.40149V10.4694H9.83545V7.18811Z",
    fill: "#D3E4EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8765 7.18811H10.4425V10.4694H10.8765V7.18811Z",
    fill: "#D3E4EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9175 7.18811H11.4835V10.4694H11.9175V7.18811Z",
    fill: "#D3E4EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9569 7.18811H12.5229V10.4694H12.9569V7.18811Z",
    fill: "#D3E4EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3364 0H11.0236V4.21167H11.3364V0Z",
    fill: "#45495A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.022 0H11.0236V2.93125H16.022V0Z",
    fill: "#E1E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0206 0H12.9814V0.488542H16.0206V0Z",
    fill: "#E96666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0206 0.813721H12.9814V1.30226H16.0206V0.813721Z",
    fill: "#E96666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0221 1.62891H11.0237V2.11745H16.0221V1.62891Z",
    fill: "#E96666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0221 2.44275H11.0237V2.93129H16.0221V2.44275Z",
    fill: "#E96666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1833 0H11.0236V1.62896H13.1833V0Z",
    fill: "#181C3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4633 0.282959L11.5354 0.430251L11.6998 0.455042L11.5816 0.568792L11.609 0.732126L11.4633 0.654834L11.3163 0.732126L11.3437 0.568792L11.2255 0.455042L11.3898 0.430251L11.4633 0.282959Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1035 0.282959L12.177 0.430251L12.3414 0.455042L12.2217 0.568792L12.2505 0.732126L12.1035 0.654834L11.9564 0.732126L11.9838 0.568792L11.8656 0.455042L12.03 0.430251L12.1035 0.282959Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7436 0.282959L12.8172 0.430251L12.9815 0.455042L12.8633 0.568792L12.8907 0.732126L12.7436 0.654834L12.5966 0.732126L12.6254 0.568792L12.5057 0.455042L12.6701 0.430251L12.7436 0.282959Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4633 0.896851L11.5369 1.04414L11.6998 1.06748L11.5816 1.18268L11.609 1.34456L11.4633 1.26873L11.3163 1.34456L11.3437 1.18268L11.2255 1.06748L11.3898 1.04414L11.4633 0.896851Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1035 0.896851L12.177 1.04414L12.3414 1.06748L12.2217 1.18268L12.2505 1.34456L12.1035 1.26873L11.9564 1.34456L11.9838 1.18268L11.8656 1.06748L12.03 1.04414L12.1035 0.896851Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7436 0.896851L12.8172 1.04414L12.9815 1.06748L12.8633 1.18268L12.8907 1.34456L12.7436 1.26873L12.5966 1.34456L12.6254 1.18268L12.5057 1.06748L12.6701 1.04414L12.7436 0.896851Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1792 4.16797V6.03755H9.33093C9.33093 5.00505 10.1585 4.16797 11.1792 4.16797Z",
    fill: "#D3E4EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0291 6.03901H11.1793V4.16797C12.2001 4.16797 13.0291 5.00505 13.0291 6.03901Z",
    fill: "#B1CFE0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.607 6.86727H8.75274L8.68787 6.03894H13.6705L13.607 6.86727Z",
    fill: "#83C0DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75274 10.4708H13.607L13.6705 11.3006H8.68787L8.75274 10.4708Z",
    fill: "#83C0DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2913 6.86731H9.06848V7.66502H13.2913V6.86731Z",
    fill: "#83C0DB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2913 6.86731H9.06848V7.26689H13.2913V6.86731Z",
    fill: "#0099C9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2913 11.3005H9.06848V12.0982H13.2913V11.3005Z",
    fill: "#83C0DB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2913 11.3005H9.06848V11.7001H13.2913V11.3005Z",
    fill: "#0099C9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1791 13.1294V23.3465H1.07837C1.07837 17.7027 5.60107 13.1294 11.1791 13.1294Z",
    fill: "#D3E4EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2799 23.345H11.1792V13.1294C16.7673 13.1294 21.2799 17.7144 21.2799 23.345Z",
    fill: "#96C3D6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2799 24.9535H1.07837V25.8008H21.2799V24.9535Z",
    fill: "#0099C9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3583 24.9535H0L0.239327 23.3464H22.119L22.3583 24.9535Z",
    fill: "#83C0DB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0186768 33.3929H22.377L22.1377 35H0.258004L0.0186768 33.3929Z",
    fill: "#83C0DB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3583 25.8008H0V27.2547H22.3583V25.8008Z",
    fill: "#83C0DB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2799 27.2548H1.07837V33.3929H21.2799V27.2548Z",
    fill: "#D3E4EF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1116 12.0983H8.2467V13.5668H14.1116V12.0983Z",
    fill: "#83C0DB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2799 27.2548H1.07837V28.5512H21.2799V27.2548Z",
    fill: "#0099C9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25987 28.8488H1.81958V32.8213H3.25987V28.8488Z",
    fill: "#0099C9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41953 28.8488H3.97925V32.8213H5.41953V28.8488Z",
    fill: "#0099C9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58054 28.8488H6.14026V32.8213H7.58054V28.8488Z",
    fill: "#0099C9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74033 28.8488H8.30005V32.8213H9.74033V28.8488Z",
    fill: "#0099C9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 28.8488H10.4597V32.8213H11.9V28.8488Z",
    fill: "#0099C9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0597 28.8488H12.6194V32.8213H14.0597V28.8488Z",
    fill: "#0099C9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2195 28.8488H14.7792V32.8213H16.2195V28.8488Z",
    fill: "#0099C9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3791 28.8488H16.9388V32.8213H18.3791V28.8488Z",
    fill: "#0099C9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5403 28.8488H19.1V32.8213H20.5403V28.8488Z",
    fill: "#0099C9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1117 12.0983L11.1792 13.5668H14.1117V12.0983Z",
    fill: "#0099C9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2799 23.345H11.1792L20.2318 18.811C20.9037 20.1775 21.2799 21.7175 21.2799 23.345Z",
    fill: "#0099C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.ee91c265d4fab1f39432c06998b38883.svg";
export { ForwardRef as ReactComponent };